/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Action_AnonymizeInputs */

const cs_gdpr_action_anonymize = /** @type {(inputs: Gdpr_Action_AnonymizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anonymizace`)
};

const en_gdpr_action_anonymize = /** @type {(inputs: Gdpr_Action_AnonymizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anonymised`)
};

/**
* | output |
* | --- |
* | "Anonymised" |
*
* @param {Gdpr_Action_AnonymizeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_action_anonymize = /** @type {((inputs?: Gdpr_Action_AnonymizeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Action_AnonymizeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_action_anonymize(inputs)
	return cs_gdpr_action_anonymize(inputs)
});